var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFrontart3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 476.61 334.11",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#a09f9f;}.cls-2{fill:#c2c1c0;}.cls-3{fill:#8f8863;}.cls-4{fill:#776f4f;}.cls-5{fill:#b58958;}.cls-6{fill:#e2ce9a;}.cls-7{fill:#ffe9b8;}.cls-8{fill:#d3c18d;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M58.84,283.6H210.38A12.37,12.37,0,0,1,222.75,296v5.74a0,0,0,0,1,0,0H46.47a0,0,0,0,1,0,0V296A12.37,12.37,0,0,1,58.84,283.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M35.66,300.06H340.51a14.84,14.84,0,0,1,14.84,14.84v3.27a0,0,0,0,1,0,0H20.83a0,0,0,0,1,0,0V314.9A14.84,14.84,0,0,1,35.66,300.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M476.61,334.11H0v-4A14.13,14.13,0,0,1,14.13,316H458.5a18.11,18.11,0,0,1,18.11,18.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M277,94.24c-3-4.44-5.26-8.1-6.19-9.67C271.74,86.13,274,89.79,277,94.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M270.77,84.5c-.06-.09-.1-.17-.15-.24S270.71,84.41,270.77,84.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M283.27,83.88l.09.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M283.2,83.74l0,.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M270.55,84.14l-.06-.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M254.79,105.06l-.15-.19Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "253.07 84.47 249.07 94.53 253.07 84.47 253.07 84.47"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M255,105.27l-.14-.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M268,103.8l-.63-.79L262.1,98.2l5.28,4.81Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M259.75,110.94c-2.34-2.67-4-4.72-4.73-5.6C255.73,106.22,257.41,108.27,259.75,110.94Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M260.56,111.85l-.8-.91Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M268.5,104.42l.56.69Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M268,103.83l.44.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M240.32,146.39l.37.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M239,145.54l.2.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M241.09,146.88l.43.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M239.47,145.84l.22.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M238.71,145.34l.12.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M238.54,145.23l.07,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M224.76,182l-1.35-.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M223.3,181.62l-1.2-.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M220,180.77c-.81-.21-1.35-.37-1.58-.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M227.76,171.43l.22.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M222.08,181.31c-.77-.19-1.44-.37-2-.52Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M218.41,180.33l-.1,0Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "205.18 164.61 205.18 164.61 213.41 169.69 205.18 164.61"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M227.6,171.38l.1,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M228.14,171.54l.33.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M335.87,218.67a75.44,75.44,0,0,0-36.44,25.83s-12.46,6.2-10.11,11.76,21.12,37.25,21.12,37.25-16.23-.09-21.42,8.73h31.73a3.72,3.72,0,0,0,3-5.91c-2.66-3.66-5.62-8.34-6.38-11.92-1.45-6.89,2.69-16.65-11.29-25.79,0,0,10.08-1.66,15.94-2.9,4.8-1,21.53-.8,31.74-10.67a76.77,76.77,0,0,1-8-25.81A87.67,87.67,0,0,1,335.87,218.67Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M389.55,316h38.37l-10.08-16.14S408.1,268.12,393,267.34L388.09,262s-9.17-45.46-30.47-79.35c-15.21-24.2-19.13-32-28-38.15a22.73,22.73,0,0,0-12.09-17.33c-13.12-7.3-31.53-38.56-34-42.88l.13.23c-2.21,3.25-4.41,6.52-6.61,9.78a154.3,154.3,0,0,0,10.55,13.89s11.09,17.07,21,33.23c-.32-.14-.64-.28-1-.41-12.7-4.81-32.51-28.4-38.48-35.76l.29.36c-2.05,3.09-4.11,6.18-6.15,9.28-1-1-1.87-2-2.71-3a165.65,165.65,0,0,0,14.66,14.66s7.43,8.45,16.25,18.77a9.66,9.66,0,0,0-6.33,4.94c-12.86-8.92-26.38-22.19-28.92-24.72l0,0-6,9.26c-3.73-3.31-6.27-5.8-6.77-6.29a182.9,182.9,0,0,0,22.89,19s11.14,10,23,21.08l-.65,0c-13-.53-37.69-15.4-46.72-21.11l.14.09c-1.88,3.05-3.73,6.13-5.5,9.24C230.92,153.56,227,151,227,151L218.49,143,227,151a183.1,183.1,0,0,0,26.38,14s11.52,6.72,24.47,14.57c-15.65,1.31-43.4-6.29-49.2-7.94l.21.06c-1.52,3.35-2.91,6.75-4.13,10.22a169.79,169.79,0,0,0,22.88,4s19.17,4.48,37.27,9.16a13.57,13.57,0,0,0,3.82,4.34c9.81,7.22,26.3,16.78,47.13,19.2a87.67,87.67,0,0,0,9.85.57,76.77,76.77,0,0,0,8,25.81c4.61,8.85,11.78,18.08,22.93,24.31A26.49,26.49,0,0,0,388,282c8.32,4.53,24.18,24.93,24.18,24.93S390.3,307.73,389.55,316Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M283.49,84.25l-.13-.22-.09-.15,0-.06,0-.08-9.07-11-2.42-9.37L266.3,72.7l4,11,.17.29.06.11.07.12c.05.07.09.15.15.24l0,.07c.93,1.57,3.16,5.23,6.19,9.67v0h0c2.2-3.26,4.4-6.53,6.61-9.78Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M269.43,105.57l-.29-.36-.08-.1-.56-.69,0,0-.44-.54,0,0-.63-.79L262.1,98.2l-5.28-4.81-3.75-8.92h0l-4,10.06,5.57,10.34.15.19,0,0,.14.18.06.07c.71.88,2.39,2.93,4.73,5.6h0l.8.91v0c.84.94,1.75,1.94,2.71,3C265.32,111.75,267.38,108.66,269.43,105.57Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M256.26,125.55l0,0-.43-.43-11.62-8.32-4.77-8.42-2.8,10.45,6.75,9.63.09.09c.5.49,3,3,6.77,6.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M236.62,156.77c1.77-3.11,3.62-6.19,5.5-9.24l-.14-.09-.46-.29-.43-.27-.4-.26-.37-.23-.63-.41-.22-.14-.26-.17-.2-.13-.18-.12-.12-.08-.1-.07-.07,0-13.06-5.79-6.37-7.28-.62,10.8L227,151S230.92,153.56,236.62,156.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M228.69,171.7l-.22-.06-.33-.1-.16,0-.22-.07-.06,0-.1,0-14.19-1.69-8.23-5.08h0l2.58,10.51,10.55,5.18.1,0h0c.23.06.77.22,1.58.43l.07,0c.55.15,1.22.33,2,.52h0l1.2.3.11,0,1.35.33h0c1.22-3.47,2.61-6.87,4.13-10.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M123.4,216.88c0,4.84-5.31,8.76-11.85,8.76s-11.84-3.92-11.84-8.76,5.3-8.77,11.84-8.77S123.4,212,123.4,216.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M139.74,216.88c0,4.84-5.3,8.76-11.84,8.76s-11.85-3.92-11.85-8.76,5.31-8.77,11.85-8.77S139.74,212,139.74,216.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M160,216.28c.24,4.84-4.86,9-11.39,9.35s-12-3.33-12.27-8.16,4.86-9,11.39-9.35S159.72,211.45,160,216.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M176,216.28c.24,4.84-4.86,9-11.4,9.35s-12-3.33-12.26-8.16,4.85-9,11.39-9.35S175.7,211.45,176,216.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M94.54,213.88h80.15a9.74,9.74,0,0,1,9.74,9.74v60a0,0,0,0,1,0,0H84.8a0,0,0,0,1,0,0v-60A9.74,9.74,0,0,1,94.54,213.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M92.34,213.88a7.54,7.54,0,0,0-7.54,7.55V283.6H97.49V213.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M184.43,219.76a7.54,7.54,0,0,0-7.55-7.54H164.66v69.72h19.77Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "125.77 228.96 123.4 236.54 142.82 232.75 125.77 228.96"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "108.71 241.16 106.34 248.74 125.77 244.95 108.71 241.16"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "134.81 239.16 134.24 247.08 152.28 238.93 134.81 239.16"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "120.44 261.99 115.34 268.08 134.74 272.02 120.44 261.99"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 142.69,
    y: 5.94,
    width: 95.55,
    height: 205.1,
    rx: 14.85,
    transform: "translate(79.76 -80.7) rotate(30)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M210.33,1.54a11.51,11.51,0,0,0-15.71,4.21l-91.05,157.7a11.51,11.51,0,0,0,4.21,15.71S191.08,42.71,215.9,4.76Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M273.16,37.82,266.5,34,158.06,208.19l12.55,7.25a11.51,11.51,0,0,0,15.71-4.21l91.05-157.7A11.5,11.5,0,0,0,273.16,37.82Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "182.51 105.34 175.22 108.48 190.76 120.75 182.51 105.34"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "232.32 78.71 225.02 81.86 240.56 94.12 232.32 78.71"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "224.95 89.58 217.66 92.72 233.2 104.99 224.95 89.58"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "217.59 100.45 210.3 103.59 225.83 115.86 217.59 100.45"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "200.19 72.7 194.67 78.41 213.73 83.74 200.19 72.7"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "219.25 28.01 213.73 33.72 232.79 39.05 219.25 28.01"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "211.89 33.53 206.37 39.24 225.43 44.58 211.89 33.53"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "204.53 39.05 199 44.77 218.06 50.1 204.53 39.05"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "195.37 81.88 188.08 85.02 203.61 97.28 195.37 81.88"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "174.07 114.98 166.77 118.13 182.31 130.39 174.07 114.98"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "165.62 124.62 158.33 127.77 173.86 140.03 165.62 124.62"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "194.19 129.1 186.9 132.24 202.44 144.51 194.19 129.1"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "143.37 150.31 135.45 152.26 157.86 172.75 143.37 150.31"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "168.16 170.98 162.43 172.39 178.66 187.23 168.16 170.98"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "160.05 179.1 154.32 180.52 170.55 195.36 160.05 179.1"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "159.02 156.59 157.02 148.68 136.66 171.21 159.02 156.59"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "149.09 116.36 144.9 109.37 131.89 136.8 149.09 116.36"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "196.68 65.97 192.49 58.98 179.48 86.42 196.68 65.97"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "209.94 30.58 208.2 22.62 187.1 44.45 209.94 30.58"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "235.44 56.05 235.89 47.92 209.73 63.33 235.44 56.05"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "132 154.8 127.81 147.81 114.8 175.25 132 154.8"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFrontart3);
export default __webpack_public_path__ + "static/media/frontart (3).4003b27b47a66440090ec6b1aec84129.svg";
export { ForwardRef as ReactComponent };